/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export const qtmTypography = {
  fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(','),
  h1: {
    fontSize: '1.875rem',
  },
  h2: {
    fontSize: '1.375rem',
  },
  h3: {
    fontSize: '1.125rem',
  },
  h4: {
    fontSize: '1rem',
  },
};
